import { useDeleteSizeGrp } from "http-hooks/sizegrp";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSizeGrp({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSizeGrp();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Order Print Group"
      description="Are you sure you want to delete this order print group? This group will be permanently removed along with all related details. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 